"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgCheckMarkSecondary = function SvgCheckMarkSecondary(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement("path", {
            d: "M28.08 7.6a1.25 1.25 0 00-.86-.34 1.26 1.26 0 00-.87.34L12.06 21.93l-6.41-6.41a1.25 1.25 0 00-.86-.34c-.32 0-.627.12-.86.34a1.22 1.22 0 000 1.73l7 7a1.57 1.57 0 001.1.46 1.57 1.57 0 001.1-.46L28.08 9.33a1.22 1.22 0 000-1.73z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    );
};

exports.default = (0, _withContainer2.default)(SvgCheckMarkSecondary);